import React from "react";
import {
  HiOutlineArrowDownTray,
  HiOutlineDocumentArrowDown,
} from "react-icons/hi2";
import { useLanguage } from "../../../contexts/LanguageContext";

export function DownloadButtons({ onDownloadPng, onDownloadPdf, downloading }) {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col gap-2">
      <button
        type="button"
        onClick={onDownloadPng}
        disabled={downloading}
        className="flex items-center justify-center gap-2 w-full py-3 rounded-lg bg-orange-500 hover:bg-orange-600 text-white font-medium text-sm disabled:opacity-50 transition-colors"
      >
        <HiOutlineArrowDownTray className="w-5 h-5" />
        {t("downloadPng")}
      </button>
      <button
        type="button"
        onClick={onDownloadPdf}
        disabled={downloading}
        className="flex items-center justify-center gap-2 w-full py-3 rounded-lg bg-white/10 hover:bg-white/20 text-white font-medium text-sm border border-white/20 disabled:opacity-50 transition-colors"
      >
        <HiOutlineDocumentArrowDown className="w-5 h-5" />
        {t("downloadPdf")}
      </button>
    </div>
  );
}
